import './FailureCardsHeader.css'

interface FailureCardsHeaderProps {
  count: number
  onAddFailure: () => void
}

function FailureCardsHeader({ count, onAddFailure }: FailureCardsHeaderProps) {
  return (
    <div data-testid="failure-cards-header" className="failure-cards-header">
      <h1 className="failure-cards-heading app-page-title">
        All Failures <span className="failure-count">({count})</span>
      </h1>
      <div className="failure-cards-header-actions">
        <button
          data-testid="add-failure-btn"
          className="add-failure-btn"
          onClick={onAddFailure}
        >
          Add Failure
        </button>
      </div>
    </div>
  )
}

export default FailureCardsHeader
